import React, { useEffect } from 'react';
import classNames from 'classnames';
import styles from './assets/expense-info.module.scss';

import { IExpense } from 'src/types/expense';
import RoleLayout from 'src/components/layout/RoleLayout';
import { RouteComponentProps } from 'react-router';

export interface StateProps {
    expense: Partial<IExpense> | null;
}

export interface DispatchProps {
    getData: (id: string | number) => void;
}

interface RouteParams {
    id: string;
}

export interface OwnProps extends RouteComponentProps<RouteParams> {}

export interface Props extends StateProps, DispatchProps, OwnProps {}

const ExpenseInfo: React.FunctionComponent<Props> = ({
    expense,
    getData,
    match: {
        params: { id },
    },
}: Props) => {
    useEffect(() => {
        if (id) {
            getData(id);
        }
        // eslint-disable-next-line
    }, [getData]);

    if (!expense) {
        return null;
    }
    return (
        <RoleLayout>
            <div>
                <h2>EXPENSES {`>`}</h2>
            </div>

            <div className={classNames(styles.infoWrap)}>
                <div className={classNames(styles.infoItems)}></div>
            </div>
        </RoleLayout>
    );
};

export default ExpenseInfo;
